import React from "react"

import * as st from './ColoredLink.styled.js'

const ColoredLink = ({
  size,
  color,
  href,
  target,
  onClick,
  children
}) => {
  const Component = target === "_blank" ? st.A :
        href ? st.Link : st.Button

  return (
    <Component
      size={size}
      color={color}
      to={href}
      href={href}
      target={target}
      onClick={onClick}
    >
      {children}
    </Component>
  )
}

export default ColoredLink
